import shipvistaAPI from "./shipvistaAPI";

export const getStatesByCountryId = (countryId: number) => {
  return shipvistaAPI.get(`/addresses/${countryId}/states/guest`);
};
